import { type Command } from '@telespot/core';

/**
 * Details for {@link SaveAssetType}
 *
 * @group Protocols
 * @category Payloads
 */
export interface SaveAssetTypeDetails {
  id: string | undefined;
  name: string;
  description?: string;
  type: 'image' | 'video' | 'text' | 'audio';
  version?: string;
  deviceTypeIds: string[];
}

/**
 * Command registration token for {@link SaveAssetType}
 *
 * @group Protocols
 * @category Tokens
 */
export const SAVE_ASSET_TYPE = 'protocols:saveAssetType';

/**
 * Saves an asset type.
 */
export class SaveAssetType implements Command<typeof SAVE_ASSET_TYPE, SaveAssetTypeDetails> {
  public readonly name = SAVE_ASSET_TYPE;
  constructor(public readonly details: SaveAssetTypeDetails) {}
}
